const REPORT_ENGINE_URL = window._env_?.REACT_APP_REPORT_ENGINE_URL
  || process.env.REACT_APP_REPORT_ENGINE_URL
  || 'http://localhost:8080';

const fetchJson = async (url) => {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`API error: ${response.status}`);
  const json = await response.json();
  return json.data || json;
};

export const adminApi = {
  // Customer Journey
  getCustomerJourneyStats: () => fetchJson(`${REPORT_ENGINE_URL}/admin/customer-journey/stats`),
  getCustomerJourneyOrgs: (stage, page = 0, size = 20) =>
    fetchJson(`${REPORT_ENGINE_URL}/admin/customer-journey/orgs?stage=${stage}&page=${page}&size=${size}`),

  // Organizations
  getOrganizations: (params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v != null && v !== '') query.set(k, v); });
    return fetchJson(`${REPORT_ENGINE_URL}/admin/organizations?${query}`);
  },
  getOrgDetail: (orgId) => fetchJson(`${REPORT_ENGINE_URL}/admin/organizations/${orgId}`),
  getOrgUsers: (orgId, page = 0, size = 20) =>
    fetchJson(`${REPORT_ENGINE_URL}/admin/organizations/${orgId}/users?page=${page}&size=${size}`),
  getOrgReports: (orgId, params = {}) => {
    const query = new URLSearchParams({ page: '0', size: '20', ...params });
    return fetchJson(`${REPORT_ENGINE_URL}/admin/organizations/${orgId}/reports?${query}`);
  },
  getOrgCompanies: (orgId, page = 0, size = 20) =>
    fetchJson(`${REPORT_ENGINE_URL}/admin/organizations/${orgId}/companies?page=${page}&size=${size}`),
  getOrgTimeline: (orgId) => fetchJson(`${REPORT_ENGINE_URL}/admin/organizations/${orgId}/timeline`),

  // Monitoring
  getOverdueAutoRefresh: (frequencyType, overdueThresholdMinutes, status) => {
    const query = new URLSearchParams();
    if (frequencyType) query.set('frequencyType', frequencyType);
    if (overdueThresholdMinutes) query.set('overdueThresholdMinutes', overdueThresholdMinutes);
    if (status) query.set('status', status);
    return fetchJson(`${REPORT_ENGINE_URL}/admin/auto-refresh/overdue?${query}`);
  },
  getDisconnectedCompanies: (params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v != null && v !== '') query.set(k, v); });
    return fetchJson(`${REPORT_ENGINE_URL}/admin/disconnected-companies?${query}`);
  },

  // Billing
  getSubscriptions: (params = {}) => {
    const query = new URLSearchParams({ page: '0', size: '20', ...params });
    return fetchJson(`${REPORT_ENGINE_URL}/admin/subscriptions?${query}`);
  },
  getUsage: (params = {}) => {
    const query = new URLSearchParams({ page: '0', size: '20', ...params });
    return fetchJson(`${REPORT_ENGINE_URL}/admin/usage?${query}`);
  },

  // Company Profiles
  getCompanyProfiles: (params = {}) => {
    const query = new URLSearchParams({ page: '0', size: '20', ...params });
    return fetchJson(`${REPORT_ENGINE_URL}/admin/company-profiles?${query}`);
  },
};
